export default __webpack_public_path__ + "static/media/heat-pump.06aba787.svg";